import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, defineMessages } from 'react-intl';
import Modal from 'components/shared/DesignSystem/Modal';
import { tokens } from '@companycam/slab';
import styled from 'styled-components';
import { Button } from '@companycam/slab-web';

const StyledModal = styled(Modal)`
  height: 354px;
  width: 450px;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: space-between;
`;

const ErrorIcon = styled.i`
  font-size: 85px;
  color: ${tokens.color_utility_destroy};
`;

const Msg = styled.p`
  font-weight: 700;
  font-size: 24px;
`;

const Description = styled.p`
  color: ${tokens.color_text_subtle_le};
`;

const messages = defineMessages({
  errorMsg: {
    id: 'Projects.taskList.exportPdf.errorMessage',
    defaultMessage: 'Error',
    description: 'Message for unsuccessful export',
  },
  errorDescription: {
    id: 'Projects.taskList.exportPdf.errorDescription',
    defaultMessage: 'There was an error retrieving the checklist PDF',
    description: 'Description for unsuccessful export',
  },
});

const ErrorModal = ({ isOpen, onRequestClose }) => {
  const { formatMessage } = useIntl();

  return (
    <StyledModal
      isOpen={isOpen}
      isClosable
      onRequestClose={onRequestClose}
      className="modal-content-wrap"
    >
      <ErrorIcon className="mdi mdi-alert" />
      <Msg> {formatMessage(messages.errorMsg)} </Msg>
      <Description> {formatMessage(messages.errorDescription)} </Description>

      <div className="btn-container">
        <Button onClick={onRequestClose}>
          {formatMessage({ id: 'Common.cancel' })}
        </Button>
      </div>
    </StyledModal>
  );
};

ErrorModal.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
};

export default ErrorModal;
